export const SET_LEADS = 'SET_LEADS';
export const SET_LEADS_LIST = 'SET_LEADS_LIST';
export const SET_TEMPLATES = 'SET_TEMPLATES';
export const SET_NUMBERS = 'SET_NUMBERS';
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO';
export const SET_CURRENT_NUMBER = 'SET_CURRENT_NUMBER';
export const CLEAR_LEADS = 'CLEAR_LEADS';